const deepClone = (obj) => obj && JSON.parse(JSON.stringify(obj))

const toStringField = (val) =>
  val === undefined
    ? undefined
    : val && typeof val === 'object'
      ? JSON.stringify(val)
      : String(val)

function loadScript (url) {
  return new Promise<void>((resolve, reject) => {
    const scriptNode = document.createElement('script')
    scriptNode.async = true
    scriptNode.src = url
    scriptNode.onload = () => resolve()
    scriptNode.onerror = (message) => reject(message)
    const firstExistingScriptNode = document.getElementsByTagName('script')[0]
    firstExistingScriptNode.parentNode.insertBefore(
      scriptNode,
      firstExistingScriptNode
    )
  })
}

export { deepClone, toStringField, loadScript }
